<template>
  <div class="competeProjectList">
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 赛事项目input -->
        <el-form-item :label="$t('lang.lab_competeItem')">
          <input style="display: none"/>
          <el-input v-model="itemName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_competeItem')"></el-input>
        </el-form-item>
        <!-- 比赛项select -->
        <el-form-item :label="$t('lang.lab_competeEvent')">
          <el-select v-model="eventId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeEvent')">
            <el-option
              v-for="(item,index) in eventNames"
              :key="index"
              :value="item.id"
              :label="item.eventName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 组别select -->
        <el-form-item :label="$t('lang.lab_competeGroup')">
          <el-select v-model="groupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeGroup')">
            <el-option
              v-for="(item,index) in groupNames"
              :key="index"
              :value="item.id"
              :label="item.groupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 年龄段select -->
        <el-form-item :label="$t('lang.lab_competeAgeGroup')">
          <el-select v-model="ageGroupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeAgeGroup')">
            <el-option
              v-for="(item,index) in ageNames"
              :key="index"
              :value="item.id"
              :label="item.ageGroupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 赛事项目 -->
        <el-table-column prop="itemName" :label="$t('lang.lab_competeItem')" :sortable="'custom'"></el-table-column>
        <!-- 赛事类别 -->
        <el-table-column prop="competeCategoryName" :label="$t('lang.lab_competeCategory')" :sortable="'custom'"></el-table-column>
        <!-- 比赛项 -->
        <el-table-column prop="itemEventName" :label="$t('lang.lab_competeEvent')"  :sortable="'custom'"></el-table-column>
        <!-- 组别 -->
        <el-table-column prop="itemGroupName" :label="$t('lang.lab_competeGroup')" :sortable="'custom'"></el-table-column>
        <!-- 年龄段 -->
        <el-table-column prop="itemAgeName" :label="$t('lang.lab_competeAgeGroup')" :sortable="'custom'"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px" label-suffix=":">
        <!-- 赛事项目名称 -->
        <el-form-item prop="itemName" :label="$t('lang.lab_competeItemName')">
          <input style="display: none"/>
          <el-input v-model="form.itemName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_competeItemName')" maxlength="20"></el-input>
        </el-form-item>
        <!-- 赛事类别 -->
        <el-form-item prop="competeCategoryId" :label="$t('lang.lab_competeCategory')">
          <el-select v-model="form.competeCategoryId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeCategory')">
            <el-option
              v-for="(item,index) in categoryNames"
              :key="index"
              :value="item.id"
              :label="item.categoryName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 比赛项 -->
        <el-form-item prop="eventId" :label="$t('lang.lab_competeEvent')">
          <el-select v-model="form.eventId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeEvent')">
            <el-option
              v-for="(item,index) in eventNames"
              :key="index"
              :value="item.id"
              :label="item.eventName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 组别 -->
        <el-form-item prop="groupId" :label="$t('lang.lab_competeGroup')">
          <el-select v-model="form.groupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeGroup')">
            <el-option
              v-for="(item,index) in groupNames"
              :key="index"
              :value="item.id"
              :label="item.groupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 年龄段 -->
        <el-form-item prop="ageGroupId" :label="$t('lang.lab_competeAgeGroup')">
          <el-select v-model="form.ageGroupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeAgeGroup')">
            <el-option
              v-for="(item,index) in ageNames"
              :key="index"
              :value="item.id"
              :label="item.ageGroupName">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
/**
 *@ClassName:competeProjectList
 *@Description:赛事项目列表
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-14
 */
export default {
  name: '',
  components: {},
  data() {
    return {
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isDisabled: true, // 确定按钮置灰
      /* 赛事项目列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      eventNames: [], // 比赛项下拉list
      ageNames: [], // 年龄段下拉list
      groupNames: [], // 组别下拉list
      itemName: '', // 筛选-赛事项目
      eventId: '', // 筛选-比赛项
      ageGroupId: '', // 筛选-年龄段
      groupId: '', // 筛选-组别
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 赛事项目列表数据
      /* 记忆筛选项值 */
      itemName_bak: '', // 备份-赛事项目
      eventId_bak: '', // 备份-比赛项
      groupId_bak: '', // 备份-年龄段
      ageGroupId_bak: '', // 备份-组别
      /* 赛事项目详情(新建编辑)变量 */
      rules: {
        itemName: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_competeItemName'), trigger: 'blur' }],
        competeCategoryId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeCategory'), trigger: 'change' }],
        eventId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeEvent'), trigger: 'change' }],
        groupId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeGroup'), trigger: 'change' }],
        ageGroupId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeAgeGroup'), trigger: 'change' }],
      },
      categoryNames: [], // 赛事类别下拉list
      form: {
        id: '',
        competeCategoryId: '',
        itemName: '',
        eventId: '',
        groupId: '',
        ageGroupId: '',
      }, // 详细数据
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取赛事项目列表数据
    getData() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize        
      }
      this.$postJson('/item/all/filterItem', params).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取赛事类别下拉list
    getCategoryList() {
      this.$get(`/competeCategory/category?status=1`).then(
        res => {
          if (res && res.code === 200) {
            this.categoryNames = res.data.list
            let newValue = {
              id: '',
              categoryName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeCategory')
            }
            this.categoryNames.unshift(newValue) 
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取年龄段下拉list
    getAgeList() {
      this.$get('/itemAge/itemAge').then(
        res => {
          if (res && res.code === 200) {
            this.ageNames = res.data.list
            let newValue = {
              id: '',
              ageGroupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeAgeGroup')
            }
            this.ageNames.unshift(newValue)  
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取组别下拉list
    getGroupList() { 
      this.$get('/itemGroup/itemGroup').then(
        res => {
          if (res && res.code === 200) {
            this.groupNames = res.data.list
            let newValue = {
              id: '',
              groupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeGroup')
            }
            this.groupNames.unshift(newValue)     
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取比赛项下拉list
    getEventList() {
      this.$get('/itemEvent/itemEvent').then(
        res => {
          if (res && res.code === 200) {
            this.eventNames = res.data.list
            let newValue = {
              id: '',
              eventName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeEvent')
            }
            this.eventNames.unshift(newValue)   
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.itemName_bak = this.itemName
        this.eventId_bak = this.eventId
        this.groupId_bak = this.groupId
        this.ageGroupId_bak = this.ageGroupId
      } else { 
        // 筛选项正确显示
        this.itemName = this.itemName_bak
        this.eventId = this.eventId_bak
        this.groupId = this.groupId_bak
        this.ageGroupId = this.ageGroupId_bak
      }
      let competeItemParaDto = {
          itemName: this.itemName,
          eventIds: this.eventId == '' ? [] : [this.eventId],
          groupIds: this.groupId == '' ? [] : [this.groupId],
          ageGroupIds: this.ageGroupId == '' ? [] : [this.ageGroupId],
          competeCategoryId: this.competeCategoryId,
          sortName: this.sortName,
          sortFieldName: this.sortFieldName,
          pageNum: this.pageNum,
          pageSize: this.pageSize        
      }
      this.$postJson('/item/all/filterItem', competeItemParaDto).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.itemName = ''
      this.eventId = ''
      this.groupId = ''
      this.ageGroupId = ''
      this.itemName_bak = ''
      this.eventId_bak = ''
      this.groupId_bak = ''
      this.ageGroupId_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.getData()
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.form.id = ''
      this.form.competeCategoryId = ''
      this.form.itemName = ''
      this.form.eventId = ''
      this.form.groupId = ''
      this.form.ageGroupId = ''
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/item/all/item/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.form.id = data.id
      this.form.competeCategoryId = data.competeCategoryId
      this.form.itemName = data.itemName
      this.form.eventId = data.eventId
      this.form.groupId = data.groupId
      this.form.ageGroupId = data.ageGroupId
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData = JSON.stringify(this.form)
      this.isShow = true
    },
    // 保存
    toSave(formName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let competeDto = this.form
          this.$postJson('/item/all/item', competeDto).then(
            res => {
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_modifySuccess')
                })
                this.handleDialogClosed()
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.competeCategoryId = ''
      this.form.itemName = ''
      this.form.eventId = ''
      this.form.groupId = ''
      this.form.ageGroupId = ''
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.competeCategoryId = ''
      this.form.itemName = ''
      this.form.eventId = ''
      this.form.groupId = ''
      this.form.ageGroupId = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
  },
  created() {
    this.getData()
    this.getCategoryList()
    this.getAgeList()
    this.getGroupList()
    this.getEventList()
  },
  mounted() {}
}
</script>

<style lang='scss'>
</style>
